export default __webpack_public_path__ + "static/media/autoconsumo-individual-con-excedentes-factura-mvl.707c4941.png";